import ecommerceOrderRoutes from "./order/routes.js";
import ecommerceProductRoutes from "./product/routes.js";

export default [
  ...ecommerceOrderRoutes,
  ...ecommerceProductRoutes
];